<div
  class="tw-flex tw-h-96 tw-flex-col tw-items-center tw-justify-center tw-bg-[url(src/assets/img/banner/sdec-banner-mobile.jpeg)] tw-bg-cover tw-bg-right tw-bg-no-repeat lg:tw-bg-[url(src/assets/img/banner/sdec-banner-desktop.jpeg)] lg:tw-bg-[40%_30%]"
>
  <div
    class="tw-flex tw-w-full tw-max-w-[1280px] tw-flex-col tw-items-center tw-gap-4 tw-px-16 tw-py-10 lg:tw-flex-row lg:tw-items-center lg:tw-justify-between lg:tw-gap-16 lg:tw-py-28"
  >
    <img
      src="/assets/img/hero/SDEC-logo-white.png"
      alt="UM Innovations"
      class="tw-w-80 lg:tw-w-[28rem]"
    />
    <h1
      class="tw-m-0 tw-flex tw-max-w-80 tw-flex-col tw-text-2xl tw-font-semibold tw-tracking-wide tw-text-white lg:tw-max-w-[40rem] lg:tw-text-4xl"
    >
      TRANSFORMING IDEAS <span class="tw-text-[2.6rem] lg:tw-text-[3.9rem]">INTO REALITY</span>
    </h1>
  </div>
</div>

<div
  class="tw-relative tw-flex tw-w-screen tw-justify-center tw-shadow-[0px_4px_32px_0px_#00000029] lg:tw-border-t"
>
  <div
    class="tw-absolute tw-left-0 tw-z-0 tw-hidden tw-h-full tw-w-6/12 tw-bg-[#2f40ee] lg:tw-flex"
  ></div>
  <div
    class="tw-absolute tw-right-0 tw-z-0 tw-hidden tw-h-full tw-w-6/12 tw-bg-transparent tw-to-[99%] lg:tw-flex lg:tw-bg-transparent"
  ></div>
  <div
    class="tw-z-10 tw-flex tw-w-full tw-max-w-[1280px] tw-flex-col lg:tw-flex-row lg:tw-justify-center"
  >
    <section
      class="tw-w-full tw-bg-[#2f40ee] tw-p-1 lg:tw-flex lg:tw-flex-1 lg:tw-justify-end lg:tw-py-4"
    >
      <div class="tw-flex tw-flex-col tw-items-center tw-p-8 lg:tw-pl-[15px]">
        <div class="tw-max-w-[35rem] tw-text-white md:tw-max-w-[80rem] lg:tw-pl-0">
          <p
            class="tw-text-left tw-text-base tw-font-semibold tw-leading-normal tw-tracking-wide sm:tw-text-sm md:tw-text-lg"
          >
            Sarawak Digital Economy Corporation (SDEC) is a wholly-owned company of the Sarawak
            Government. Operational since July 2020, SDEC is mandated to drive digital
            transformation across Sarawak, benefiting both businesses and local communities.
          </p>
          <p
            class="tw-text-left tw-text-base tw-font-normal tw-leading-normal sm:tw-text-sm md:tw-text-lg"
          >
            SDECʼs main roles are to accelerate economic growth by enabling a thriving and inclusive
            private sector economy, bridging the digital gap by providing and expanding internet
            connectivity in the suburban and rural areas, and catalysing a culture of innovation
            through development programmes for innovators and tech founders. For more information on
            SDEC, visit
            <a
              href="http://www.sdec.com.my"
              class="tw-text-white hover:tw-text-white hover:tw-underline"
              >www.sdec.com.my.</a
            >
          </p>
        </div>
      </div>
    </section>
    <section
      class="tw-flex tw-flex-col tw-items-center tw-bg-white tw-p-6 tw-text-[#2f40ee] lg:tw-max-w-[20rem] lg:tw-items-start lg:tw-justify-start lg:tw-py-12 lg:tw-pl-14"
    >
      <p
        class="tw-mb-1 tw-text-center tw-text-base md:tw-text-lg lg:tw-text-left lg:tw-text-lg lg:tw-font-thin"
      >
        Ready to take your startup to the next level?
      </p>
      <p class="tw-text-xl tw-font-semibold tw-tracking-wide lg:tw-text-lg">Discover how.</p>
      <a
        class="tw-flex tw-w-full tw-cursor-pointer tw-justify-center tw-rounded-md tw-bg-[#f08218] tw-p-4 tw-text-base tw-font-semibold tw-text-white tw-shadow-[0px_4px_4px_0px_#00000040] hover:tw-border-none hover:tw-text-white hover:tw-outline-none lg:tw-mt-2 lg:tw-px-4 lg:tw-py-2 lg:hover:tw-bg-opacity-80 lg:hover:tw-text-[#0000FF]"
        href="https://forms.gle/qwSG2a7YP1HxPyoK6"
        target="_blank"
      >
        Book a session with us
      </a>
    </section>
  </div>
</div>

<app-partner-page-campaigns class="tw-text-[#2f40ee]" />

<section
  class="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-bg-[#2f40ee] tw-p-8 md:tw-gap-8 md:tw-p-16"
>
  <h3 class="tw-font-heading tw-text-xl tw-font-bold tw-tracking-wide tw-text-white md:tw-text-4xl">
    About SDEC
  </h3>
  <div class="tw-flex tw-max-w-[35rem] tw-flex-col md:tw-max-w-4xl">
    <p class="tw-text-left tw-text-base tw-text-white  md:tw-text-lg">
      Sarawak Digital Economy Corporation (SDEC) is a wholly-owned company of the Sarawak
      Government. Operational since July 2020, SDEC is mandated to drive digital transformation
      across Sarawak, benefiting both businesses and local communities.
    </p>
    <p class="tw-text-left tw-text-base tw-text-white  md:tw-text-lg">
      SDEC's main roles are to accelerate economic growth by enabling a thriving and inclusive
      private sector economy, bridging the digital gap by providing and expanding internet
      connectivity in the suburban and rural areas, and catalysing a culture of innovation through
      development programmes for innovators and tech founders. For more information on SDEC, visit
      <a href="http://www.sdec.com.my" class="tw-text-white hover:tw-text-white hover:tw-underline"
        >www.sdec.com.my</a
      >
    </p>
    <p class="tw-text-left tw-text-base tw-text-white  md:tw-text-lg">
      SARAWAK DIGITAL ECONOMY CORPORATION BHD (1265203-A) <br />(A wholly owned subsidiary of the
      Government of Sarawak) Wisma Satok, Level 6, 93050 Kuching, Sarawak, Malaysia<br />
      Tel: +6082 549 005 | Fax: +6082 523 005 | Email:
      <a
        href="mailto:hello@sdec.com.my"
        class="tw-text-white hover:tw-text-white hover:tw-underline"
        >hello&#64;sdec.com.my</a
      >
    </p>
  </div>

  <a
    href="http://www.sdec.com.my"
    target="_blank"
    class="tw-rounded-full tw-bg-[#f08117] tw-px-6 tw-py-4 tw-text-base tw-font-semibold tw-text-white hover:tw-bg-opacity-80 hover:tw-text-white md:tw-text-lg"
    >More on SDEC Innovations</a
  >
</section>
